exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-size[data-v-a70ecb2a]{font-size:1.2em}.couleur-orange[data-v-a70ecb2a]{color:#ff9800;font-size:1.2em}.white-couleur[data-v-a70ecb2a]{color:#fff}.v-data-table-header[data-v-a70ecb2a]{background-color:#78b943;color:#fff}.theme--light.v-datatable thead th.column.sortable.active[data-v-a70ecb2a],.theme--light.v-table thead th[data-v-a70ecb2a]{color:#fff}.a-sans-style a[data-v-a70ecb2a]{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a70ecb2a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/organizations/show.vue
// module id = bsBS
// module chunks = 1